var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLounge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.71403 16.4961L5.98572 13.5257C5.8186 13.3501 5.61974 13.213 5.40138 13.1229C5.18301 13.0327 4.94976 12.9914 4.71594 13.0015C4.26085 13.0015 3.82441 13.1953 3.50261 13.5402C3.18081 13.8851 3.00003 14.353 3.00003 14.8408C2.99871 15.085 3.0428 15.3271 3.12971 15.5529C3.21662 15.7787 3.34461 15.9837 3.50622 16.1559L7.09249 20H19.3613C19.5768 20.0012 19.7904 19.9566 19.9897 19.8688C20.1891 19.7809 20.3702 19.6516 20.5225 19.4882C20.6749 19.3249 20.7956 19.1307 20.8776 18.9171C20.9595 18.7034 21.0011 18.4745 21 18.2435C21 18.0132 20.9575 17.7852 20.8751 17.5726C20.7926 17.3601 20.6718 17.167 20.5195 17.0046C20.3672 16.8423 20.1865 16.7138 19.9877 16.6265C19.789 16.5392 19.5761 16.4949 19.3613 16.4961H8.71403Z",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 22V20",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 22V20",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3C15.5312 3 18.5793 5.04375 20 8H4C5.42069 5.04375 8.46882 3 12 3Z",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16V9",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22V20",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLounge);
export default __webpack_public_path__ + "static/media/Lounge.a3c71ffb2cae9f6c1940b41254fe4662.svg";
export { ForwardRef as ReactComponent };